function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.10000000149011613, 0, 0, -0.10000000149011613, -33.16208316627271, 157.4944176300528)",
  fill: "#000000",
  stroke: "none",
  id: "object-0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M885 1566 c-277 -54 -485 -259 -542 -534 -20 -99 -13 -252 16 -342 64 -200 228 -363 439 -438 69 -24 91 -27 207 -26 114 0 139 3 206 26 347 121 537 471 444 820 -61 232 -260 429 -488 483 -93 22 -203 26 -282 11z m264 -61 c233 -55 424 -261 467 -505 35 -199 -27 -390 -176 -541 -90 -92 -200 -152 -319 -176 -299 -59 -608 124 -706 417 -111 333 78 697 413 796 93 28 226 31 321 9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1170 1252 c12 -30 15 -55 10 -71 -24 -80 -41 -183 -35 -213 4 -22 1 -48 -9 -73 -9 -20 -16 -64 -16 -95 0 -50 -4 -61 -24 -78 -56 -44 -94 -130 -65 -148 6 -4 8 -20 4 -40 -3 -21 -2 -34 4 -34 17 0 129 61 144 79 19 22 37 77 37 113 0 17 16 57 38 91 l37 61 -2 148 c-1 167 1 159 -86 249 l-54 56 17 -45z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M876 1260 c15 -41 9 -93 -15 -151 -16 -35 -24 -75 -25 -114 -1 -40 -7 -68 -19 -85 -10 -14 -17 -43 -17 -68 0 -38 -6 -49 -52 -99 -51 -54 -53 -57 -53 -114 -1 -32 3 -59 8 -59 5 0 34 7 64 16 47 14 59 22 84 62 16 25 29 58 29 73 0 14 13 43 29 63 44 55 59 109 65 234 6 128 3 140 -65 218 -30 35 -39 41 -33 24z"
}));

function SvgSoybeanCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 134.6893 134.9107",
    width: "134.689pt",
    height: "134.911pt",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoybeanCircleIcon);
export default __webpack_public_path__ + "static/media/SoybeanCircleIcon.7bb2aa80.svg";
export { ForwardRef as ReactComponent };